import React, { memo } from "react";
import { classNames } from "helpers";
import { ReactSVG } from "react-svg";

interface ContactStepStatusBarProps {
  stepLabels: string[];
  stepCurrent: number;
  onStepClick?: (stepIndex: number) => void;
  firstStepCompleted?: boolean;
}

const ContactStepStatusBar: React.FC<ContactStepStatusBarProps> = ({
  stepLabels,
  stepCurrent,
  onStepClick,
  firstStepCompleted = false,
}) => {
  return (
    <div className="w-50 flex border border-x-0 border-t-0 border-slate-200 overflow-hidden  ">
      {stepLabels.map((label, index) => {
        const isActive = index === stepCurrent;
        const isPast = index < stepCurrent;
        const isFirstStep = index === 0;
        // Dok kontakt nije spremljen (prvi korak nije prošao validaciju), sve je zaključano —
        // naprijed se ide samo kroz "Nastavi". Nakon toga slobodno na bilo koji korak, kao kod
        // vozila; klik sprema i validira trenutni korak (ContactEditCard.handleStepClick).
        const isDisabled = firstStepCompleted ? isActive : true;

        // Prvi korak je "u tijeku" (svijetlo plavo, bez kvačice) dok se radi
        // unos i još nije uspješno spremljen. Čim se pređe na drugi korak — ili
        // u editu, gdje je od početka spremljen — postaje gotov: svijetlo zeleno
        // s kvačicom.
        const isCompleted =
          isPast || (isActive && isFirstStep && firstStepCompleted);
        const isInProgress = isActive && !isCompleted;

        return (
          <button
            key={index}
            type="button"
            disabled={isDisabled}
            onClick={() => !isDisabled && onStepClick?.(index)}
            className={classNames(
              "flex-1 flex items-center justify-center gap-2 py-2.5 px-3 text-sm border-r last:border-r-0 transition-all duration-200",
              isCompleted
                ? "bg-green-100 text-green-800 font-semibold border-b-2 border-b-green-600"
                : isInProgress
                  ? "bg-sky-50 text-sky-700 font-medium border-slate-200"
                  : "bg-white text-slate-400 font-medium border-slate-200",
              !isDisabled && "cursor-pointer hover:opacity-80"
            )}
          >
            {isCompleted && (
              <ReactSVG
                src="/media/icons/check.svg"
                className="w-4 h-4 stroke-green-700"
              />
            )}
            <span>{label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default memo(ContactStepStatusBar);
